// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"89989942","150":"ca7f213c","261":"11149871"}[chunkId] + ".chunk.js";
};